<template>
  <div class="operate-content">
    <div class="title-box">
      <div class="operate-title" v-if="awardList.length">
        {{ awardList[current] && awardList[current].awardAliasName }}
      </div>
    </div>
    <div class="carousel-con">
      <el-carousel
        v-if="awardList.length"
        ref="mySwiper"
        class="carousel"
        arrow="never"
        :autoplay="false"
        :initial-index="current"
        indicator-position="none"
        @change="carouselChange"
      >
        <el-carousel-item
          v-for="(item, i) in awardList"
          :key="i"
          class="carousel-item"
        >
          <div class="img-wrap">
            <img :src="item.awardPicUrl" alt="" class="prize-img" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div
        :class="{
          roll: true,
          'lt-roll': true,
          'disable-roll': isBegin || disabledChange,
        }"
        @click="toLeft"
      >
        <img src="https://m.elongstatic.com/year-wish/change_left.png" />
      </div>
      <div
        :class="{
          roll: true,
          'rt-roll': true,
          'disable-roll': isBegin || disabledChange,
        }"
        @click="toRight"
      >
        <img src="https://m.elongstatic.com/year-wish/change_right.png" />
      </div>
    </div>
    <div class="prize-title">
      {{ awardList[current] && awardList[current].awardName }}
    </div>
    <div class="people-con" v-if="awardList.length">
      <div class="people-lf">
        <div>抽取人数：</div>
        <div class="people-num">
          {{ awardTotal(awardList[current].awardCount, awardList[current]) }}
        </div>
        <!--<div>人</div>-->
      </div>
      <div class="people-rt">
        <div class="people-operate lf-po" @click="reduce">
          <img src="https://m.elongstatic.com/year-wish/newDel.png" />
        </div>
        <el-input-number
          class="edit-num"
          v-model="plusPeopleNum"
          :max="maxNum"
          :min="0"
          :controls="false"
          @input="updatePlusPeopleNum"
        />
        <div class="people-operate rt-po" @click="plus">
          <img src="https://m.elongstatic.com/year-wish/newAdd.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { debounce } from "../../../utils/utils";
import { queryActivityDetail } from "../../../service/api";
export default {
  props: {
    awardList: {
      type: Array,
      default: [],
    },
    isBegin: {
      type: Boolean,
      default: false,
    },
    unWinParticipants: {
      type: Number,
      default: 0,
    },
    isLottery: {
      type: Number,
      default: 0,
    },
    controlNum: {
      type: Number,
      default: 0,
    },
    userData: {
      type: Array,
      default: [],
    },
    awardId: {
      type: Number | String,
      default: 0,
    },
    isEnding: {
      type: Boolean,
      default: false,
    },
    disabledChange: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      current: 0, // 下标
      peoples: 20,
      plusPeopleNum: 0,
      unWinParticipantsDeep: 0,
      unWinParticipants: [],
    };
  },
  watch: {
    plusPeopleNum(newVal) {
      this.$emit("updateNum", newVal);
    },
    controlNum() {
      this.plusPeopleNum = 0;
    },
    awardList(newVal) {
      const index = newVal.findIndex((v) => v.id == this.awardId);
      this.current = index;
    },
    unWinParticipants(newVal) {
      if (Array.isArray(newVal)) {
        this.unWinParticipantsDeep = newVal.length;
      } else {
        this.unWinParticipantsDeep = newVal;
      }
    },
  },
  computed: {
    awardTotal() {
      return function (val, item) {
        return item.isLottery
          ? Number(this.plusPeopleNum)
          : Number(val) + Number(this.plusPeopleNum);
      };
    },
    maxNum() {
      let length = 0;
      if (this.isLottery) {
        length = this.unWinParticipantsDeep;
      } else {
        length =
          Number(this.unWinParticipantsDeep) -
          Number(this.awardList[this.current].awardCount);
      }
      return length;
    },
  },
  mounted() {
    // 监听 空格键
    window.addEventListener("keydown", this.handleKeyDown, true);
  },
  methods: {
    updatePlusPeopleNum(e) {
      if (!e) {
        this.plusPeopleNum = 0;
      }
    },
    handleKeyDown(e) {
      console.log(e, "键盘事件");
      const code = e.keyCode; // 32 是空格键
      if (code === 32) {
        if (!this.isBegin) {
          console.log("开始抽奖了");
          this.onStart();
        } else {
          console.log("暂停了");
          this.onStop();
        }
      } else if (code === 37) {
        this.toLeft();
      } else if (code === 39) {
        this.toRight();
      }
    },
    toLeft() {
      if (this.disabledChange) return;
      if (!this.isBegin) {
        this.$refs.mySwiper.prev();
        this.plusPeopleNum = 0;
      }
    },
    toRight() {
      if (this.disabledChange) return;
      if (!this.isBegin) {
        this.$refs.mySwiper.next();
        this.plusPeopleNum = 0;
      }
    },
    //轮播切换事件
    carouselChange(e) {
      this.current = e;
      this.$emit("swiper", e);
    },
    //增加人数
    plus() {
      if (this.disabledChange) return;
      if (!this.isBegin) {
        if (!this.unWinParticipantsDeep) {
          alert("暂无可抽奖用户");
          return;
        }
        if (Number(this.plusPeopleNum) < this.unWinParticipantsDeep) {
          this.plusPeopleNum += 1;
          this.$emit("getDetail");
        }
      }
    },
    //减少人数
    reduce() {
      if (this.disabledChange) return;
      if (!this.isBegin) {
        if (!this.unWinParticipantsDeep) {
          alert("暂无可抽奖用户");
          return;
        }
        if (this.plusPeopleNum > 0) {
          this.plusPeopleNum -= 1;
          this.$emit("getDetail");
        }
      }
    },
    //开始抽奖
    onStart: debounce(async function () {
      const query = this.$route.query;
      const { awardId, activityId } = query;
      const res = await queryActivityDetail({
        activityId: activityId,
      });
      if (res.code === "0") {
        const data = res.data || {};
        const rewardsArr = data.awards || [];
        const aId = this.awardList[this.current].id;
        const rewards = rewardsArr.find((item) => item.id == aId);
        const { userGroup } = rewards || {};
        this.unWinParticipantsList =
          data.unWinParticipants.filter((i) => i.userGroup == userGroup) || [];
        this.unWinParticipantsDeep = this.unWinParticipantsList.length;
        // this.unWinParticipantsDeep = this.unWinParticipants.length;
        if (this.isLottery && !this.plusPeopleNum) {
          alert("当前可抽奖品数量已用完");
          return;
        }
        if (!this.unWinParticipantsDeep) {
          alert("暂无可抽奖用户");
          return;
        }
        const total = this.isLottery
          ? Number(this.plusPeopleNum)
          : this.awardList[this.current].awardCount +
            Number(this.plusPeopleNum);
        if (total > this.unWinParticipantsDeep) {
          alert("请确认相关人数符合抽奖固定,抽奖人数必须大于奖品个数");
          return;
        }
        // return;
        this.$emit("start");
      }
    }, 300),
    //暂停
    onStop: debounce(function () {
      if (!this.isEnding) {
        this.$emit("stop");
      }
    }, 300),
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input-number .el-input {
  display: flex;
}
::v-deep .el-input .el-input__inner {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: #ea6f3f;
  border: none;
  font-size: 12PX;
  font-weight: 550;
  color: #ffffff;
  padding: 0 6PX !important;
}
.operate-content {
  position: relative;
  width: 348PX;
  height: 400PX;
  background: linear-gradient(180deg, #fff1db, #ffdfb9 100%);
  border-radius: 10PX;
  margin-right: 12PX;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  //   padding-bottom: 40PX;
  .title-box {
    z-index: 1000;
    width: 302.5PX;
    height: 50PX;
    background-image: url("https://m.elongstatic.com/year-wish/newTitleBg.png");
    background-size: 100% 100%;
    position: absolute;
    top: -25PX;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .operate-title {
    width: 180PX;
    font-size: 20PX;
    // opacity: 0.8;
    font-weight: 550;
    color: #fff3df;
    line-height: 20PX;
    // margin-top: 75PX;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .prize-title {
    width: 90%;
    text-align: center;
    font-size: 15PX;
    font-weight: 550;
    color: #980f16;
    line-height: 17PX;
    margin: 20PX 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .carousel-con {
    position: relative;
    width: 90%;
    height: 224PX;
    margin-top: 36PX;
    overflow: hidden;
  }
  .roll {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      width: 20PX;
      height: 20PX;
    }
  }
  .lt-roll {
    position: absolute;
    left: 10PX;
    top: 50%;
    margin-top: -10PX;
    z-index: 5;
  }
  .disable-roll {
    cursor: not-allowed;
  }
  .rt-roll {
    position: absolute;
    right: 10PX;
    top: 50%;
    margin-top: -10PX;
    z-index: 5;
  }
  .carousel {
    margin: 0 auto;
    width: 100%;
    height: 224PX;
    overflow: hidden;
    // position: relative;

    .carousel-item {
      width: 100%;
      height: 224PX;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      //   padding-top: calc((100vh - 300PX - 89PX) * 0.1);
      box-sizing: border-box;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .img-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 224PX;
      height: 224PX;
      border: 2PX solid #ffd5a0;
      border-radius: 10PX;
      overflow: hidden;
    }
    .prize-img {
      width: 224PX;
      max-height: 224PX;
      height: auto;
      //   border-radius: inherit;
    }
  }
  .people-con {
    width: 298.5PX;
    height: 45PX;
    background: #ffd5a0;
    border-radius: 8PX;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16PX;
    box-sizing: border-box;
    .people-lf {
      color: #980f16;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 12PX;
      font-weight: 550;
      //   line-height: 28PX;
      .people-num {
        width: 35.5PX;
        height: 24PX;
        background: #ea6f3f;
        border-radius: 2PX;
        padding: 0;
        margin: 0;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 30PX;
        font-size: 12PX;
        color: #fff;
      }
    }
    .people-rt {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100.5PX;
      height: 27PX;
      border: 1PX solid #ea6f3f;
      border-radius: 3PX;
      .edit-num {
        width: 46.5PX;
        height: 27PX;
        background: #ea6f3f;
        text-align: center;
        border: none;
        font-size: 12PX;
        font-weight: 550;
        color: #ffffff;
        display: flex;
        align-items: center;
        // line-height: 46PX;
      }
      .people-operate {
        width: 27PX;
        height: 27PX;
        // background: #fd8100;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 16PX;
          height: 16PX;
        }
      }
      //   .lf-po {
      //     border-top-left-radius: calc((100vh - 300PX - 89PX) * 0.0088);
      //     border-bottom-left-radius: calc((100vh - 300PX - 89PX) * 0.0088);
      //     margin-left: 1PX;
      //   }
      //   .rt-po {
      //     border-top-right-radius: calc((100vh - 300PX - 89PX) * 0.0088);
      //     border-bottom-right-radius: calc((100vh - 300PX - 89PX) * 0.0088);
      //     margin-right: 1PX;
      //   }
    }
  }
}
</style>
